export default "/images/5059812bbf9c487eba0fd153accee636.avif";